<div id="workflow-modal">
  <div class="modal-header">
    <h3 class="modal-title">
      {{ title }}
      <i class="fa fa-times pull-right" (click)="close()"></i>
      <i class="fa pull-right"
         [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
         style="margin-right: 10px"
         (click)="minimise = !minimise"></i>
    </h3>
  </div>

  <div class="modal-body" [hidden]="minimise">
    <form novalidate>
      <!-- CATEGORY FORM -->
      @if (origin === 'Category') {
<div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label>Category Name: *</label>
            <input type="text" class="form-control"
                   [(ngModel)]="name" name="name"
                   [class.error-field]="isNameMissing()" />
          </div>
          <div class="form-group">
            <label>Is Active: *</label>
            <select class="form-control"
                    [(ngModel)]="selectedIsActive" name="selectedIsActive"
                    [class.error-field]="isSelectedIsActiveMissing()">
              <option value="">Choose</option>
              <option value="1">Yes</option>
              <option value="0">No</option>
            </select>
          </div>
        </div>
        <div class="form-group col-md-6">
          <label>Description:</label>
          <textarea class="form-control" placeholder="Add Message"
                    [(ngModel)]="description" name="description"
                    style="height: 7.75em;"></textarea>
        </div>
      </div>
}

      <!-- STEP FORM -->
      @if (origin === 'Step') {
<div class="row">
        <div class="col-md-4">
          <div class="form-group">
            <label>Step Name: *</label>
            <input type="text" class="form-control"
                   [(ngModel)]="name" name="name"
                   [class.error-field]="isNameMissing()" />
          </div>
          <div class="form-group">
            <label>Priority: *</label>
            <input type="text" class="form-control"
                   [(ngModel)]="priority" name="priority"
                   [class.error-field]="isPriorityMissing()" />
          </div>
        </div>
        <div class="col-md-4">
          <div class="form-group">
            <label>Category Name: *</label>
            <select class="form-control"
                    [(ngModel)]="selectedCategory" name="selectedCategory"
                    [class.error-field]="isSelectedCategoryMissing()">
              <option value="">Select</option>
              @for (cat of availableCategories; track $index) {
<option [value]="cat.child_id">{{ cat.name }}</option>
}
            </select>
          </div>
        </div>
        <div class="col-md-4">
          <div class="form-group">
            <label>Is Active: *</label>
            <select class="form-control"
                    [(ngModel)]="selectedIsActive" name="selectedIsActive"
                    [class.error-field]="isSelectedIsActiveMissing()">
              <option value="">Choose</option>
              <option value="1">Yes</option>
              <option value="0">No</option>
            </select>
          </div>
          <div class="form-group">
            <label>Description:</label>
            <textarea class="form-control" placeholder="Add Message"
                      [(ngModel)]="description" name="description"
                      style="height: 13em;"></textarea>
          </div>
        </div>
      </div>
}
    </form>
  </div>

  <div class="modal-footer" [hidden]="minimise">
    <button type="button" class="btn btn-primary" (click)="save()" [disabled]="saving">
      Save @if (saving) {
<i class="fa fa-spinner fa-spin"></i>
}
    </button>
    <button type="button" class="btn btn-warning" (click)="close()">Cancel</button>
  </div>
</div>
